import api from '../apis/ufrnApi'

export const itemRepositoryService = itemId => {
    let url = `/repositorios/${itemId}`
    return api.get(url)
}

export const repositoryItemTypeService = () => {
    let url = '/repositorios/tipos-item'
    return api.get(url)
}